import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { instance } from "../configApi";

const initialState = {
  msg: "",
  isError: false,
  isNotify: false,
  typeNotify: "",
  isLoading: false,
  callBackRequest: false,
  isOpenModalAddProduct: false,
  isOpenModalDetail: false,
  isOpenModalEdit: false,
  isOpenModalConfirm: false,
  isOpenModalGetLog: false,
  dataLog: [],
  contentConfirm: "",
  idTemplatesMessage: "",
  isOpenModalAddCategry: false,
  callBackRequestCategory: false,
  dataBasePageOne: [],
  refetchAPI: false,
  detailByID: [],
  isOpenModalPostTemplatesMessage: false,
  isOpenModalEditTemplatesMessage: false,
  data: [],
  total: 0,
  dataCategory: [],

  dataTemplateMessage: [],
  dataTemplateMessageDetail: {},

  config: {
    search: "",
    status: 2,
    categoryId: 0,
    option: {
      limit: 10,
      offset: 1,
      order: "desc",
    },
  },
};
const TemplatesMessageSlice = createSlice({
  name: "templatesMessage",
  initialState,
  reducers: {
    resetState: (state) => {
      state.msg = "";
      state.isNotify = false;
      state.typeNotify = "";
      state.isLoading = false;
      state.callBackRequest = false;
      state.isOpenModalAddProduct = false;
      state.isOpenModalDetail = false;
      state.isOpenModalEdit = false;
      state.isOpenModalConfirm = false;
      state.isOpenModalGetLog = false;
      state.dataLog = [];
      state.contentConfirm = "";
      state.idTemplatesMessage = "";
      state.isOpenModalAddCategry = false;
      state.callBackRequestCategory = false;
      state.detailByID = [];
      state.data = [];
      state.total = 0;
      state.dataCategory = [];
      state.config.search = "";
      state.config.status = 2;
      state.config.categoryId = 0;
      state.config.option.limit = 10;
      state.config.option.offset = 1;
      state.config.option.order = "desc";
    },
    setSearchText: (state, action) => {
      state.config.search = action.payload;
    },
    setStatusProduct: (state, action) => {
      state.config.option.offset = 1;
      state.config.status = action.payload;
    },
    setCategoryId: (state, action) => {
      state.config.categoryId = action.payload;
    },
    setPageProduct: (state, action) => {
      state.config.option.offset = action.payload;
    },
    setOpenDetailTemplatesMessage: (state, action) => {
      state.isOpenModalDetail = action.payload.isOpen;
      state.idTemplatesMessage = action.payload.id;
    },
    setPage: (state, action) => {
      state.config.option.offset = action.payload;
    },
    setOpenModalPostTemplatesMessage: (state, action) => {
      state.isOpenModalPostTemplatesMessage = action.payload;
    },
    setOpenEditTemplatesMessage: (state, action) => {
      state.isOpenModalEditTemplatesMessage = action.payload.isOpen;
      state.idTemplatesMessage = action.payload.id;
    },
    setOpenModalGetLogTemplatesMessage: (state, action) => {
      state.isOpenModalGetLog = action.payload;
    },
    resetStatus: (state) => {
      state.isLoading = false;
      state.isNotify = false;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      //get all template message
      .addCase(getTemplatesMessageAll.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTemplatesMessageAll.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataTemplateMessage = action.payload;
      })
      .addCase(getTemplatesMessageAll.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })

      //get detail template message
      .addCase(getTemplatesMessageDetail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTemplatesMessageDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataTemplateMessageDetail = action.payload;
      })
      .addCase(getTemplatesMessageDetail.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })

      //get data log
      .addCase(getLogTemplateMessage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLogTemplateMessage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dataLog = action.payload;
      })
      .addCase(getLogTemplateMessage.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })

      //add template message
      .addCase(addTemplatesMessage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addTemplatesMessage.fulfilled, (state, action) => {
        console.log("action",action);
        
        if (action.payload.status === 200) {
          state.isNotify = true;
          state.isLoading = false;
          state.typeNotify = "success";
          state.msg = "Thêm cấu hình tin nhắn thành công";
        } else {
          state.isNotify = true;
          state.isLoading = false;
          state.typeNotify = "error";
          state.msg = "Có lỗi xảy ra, vui lòng thử lại sau";
        }
      })
      .addCase(addTemplatesMessage.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
        state.typeNotify = "error";
        state.msg = "Có lỗi xảy ra, vui lòng thử lại sau";
      })

      //update template message
      .addCase(updateTemplatesMessage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateTemplatesMessage.fulfilled, (state, action) => {
        if (action.payload.status === 200) {
          state.typeNotify = "success";
          state.msg = "Sửa thông tin thành công";
          state.isLoading = false;
          state.detailByID = action.data;
          state.isNotify = true;
        } else {
          state.isNotify = true;
          state.isLoading = false;
          state.typeNotify = "error";
          state.msg = "Có lỗi xảy ra, vui lòng thử lại sau";
        }
      })
      .addCase(updateTemplatesMessage.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
        state.typeNotify = "error";
        state.msg = "Có lỗi xảy ra, vui lòng thử lại sau";
      })

      //delete template message
      .addCase(deleteTemplatesMessage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteTemplatesMessage.fulfilled, (state, action) => {
        if (action.payload.status === 200) {
          state.isNotify = true;
          state.isLoading = false;
          state.typeNotify = "success";
          state.msg = "Xóa cấu hình tin nhắn thành công";
        } else {
          state.isNotify = true;
          state.isLoading = false;
          state.typeNotify = "error";
          state.msg = "Sửa thông tin sản phẩm thất bại";
        }
      })
      .addCase(deleteTemplatesMessage.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
        state.typeNotify = "error";
        state.msg = "Sửa thông tin sản phẩm thất bại";
      });
  },
});
export default TemplatesMessageSlice;

export const {
  setCategoryId,
  setStatusProduct,
  setOpenEditProduct,
  setOpenDetailChatBkavPro,
  setOpenModalConfirm,
  resetStatus,
  setPageProduct,
  setSearchText,
  setOpenModalAddProduct,
  setOpenModalAddCategory,
  setOpenModalGetLogStore,
  resetState,
  setOpenDetailTemplatesMessage,
  setOpenModalPostTemplatesMessage,
  setOpenEditTemplatesMessage,
  setOpenModalGetLogTemplatesMessage,
  setPage,
} = TemplatesMessageSlice.actions;

export const getTemplatesMessageAll = createAsyncThunk(
  "templatesMessage/getTemplatesMessageAll",
  async (id) => {
    try {
      const res = await instance.get(`/message-templates`);
      return res.data.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
export const getTemplatesMessageDetail = createAsyncThunk(
  "templatesMessage/getTemplatesMessageDetail",
  async (id) => {
    try {
      const res = await instance.get(`/message-templates/${id}`);
      return res.data.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
export const getLogTemplateMessage = createAsyncThunk(
  "templatesMessage/getLogTemplateMessage",
  async (id) => {
    try {
      const res = await instance.get(
        `/message-template-logs/message-template/${id}`
      );
      return res.data.data;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);

export const addTemplatesMessage = createAsyncThunk(
  "templatesMessage/addTemplatesMessage",
  async (data, { getState, dispatch }) => {
    try {
      const res = await instance.post("/message-templates", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = res.data;
      const state = getState();
      const { keySearch } = state.templatesMessage;
      dispatch(getTemplatesMessageAll({ keySearch: keySearch }));
      dispatch(setOpenModalPostTemplatesMessage(false));
      return result;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);

export const updateTemplatesMessage = createAsyncThunk(
  "templatesMessage/updateTemplatesMessage",
  async ({ formPost, datapost }, { getState, dispatch }) => {
    try {
      const res = await instance.put(
        `/message-templates/${datapost?.id}`,
        formPost,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const result = res.data;
      const state = getState();
      const { keySearch } = state.templatesMessage;
      dispatch(getTemplatesMessageAll({ keySearch: keySearch }));
      dispatch(setOpenEditTemplatesMessage({ isOpen: false, id: "" }));
      return result;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);

export const deleteTemplatesMessage = createAsyncThunk(
  "templatesMessage/deleteTemplatesMessage",
  async (id, { getState, dispatch }) => {
    try {
      const res = await instance.delete(`/message-templates/${id}`);
      const result = res.data;
      const state = getState();
      const { keySearch } = state.templatesMessage;
      dispatch(getTemplatesMessageAll({ keySearch: keySearch }));
      return result;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
